import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Table,
  Segment,
  Header,
  Label,
  Loader,
  Message,
  Button,
  Icon,
  Divider,
} from 'semantic-ui-react';
import LocalStorage from '../../../lib/LocalStorage';
import config from '../../../common/repository/config';
import { toast } from '../../common/Toast';
import moment from 'moment';

interface DailyStatus {
  service_type: string;
  service_status: string;
}

const ReportStatusList: React.FC = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const history = useHistory();
  const [data, setData] = useState([]);
  const handleDelete = async (id: string) => { 
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        setError('Authentication token is missing.');
        return;
      }

      const url = `${config.apiBaseURL}/case/delete/generation/status`;
      const payload = {
        reportId: id
      }
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      const resData = await response.json();
      toast.success(resData.message);
      window.location.reload();
    } catch (e) {
      setError('Something went wrong while fetching data.');
    } finally {
      setLoading(false);
    }
  }

  const fetchReportStatusList = async () => {
      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          setError('Authentication token is missing.');
          return;
        }

        const url = `${config.apiBaseURL}/case/userReportStatus`;

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
        });

        if (!response.ok) {
          throw new Error(`${response.status}`);
        }
        const resData = await response.json();
        console.log(resData)
        setData(resData.data.items)
      } catch (e) {
        setError('Something went wrong while fetching data.');
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
    fetchReportStatusList();
  }, []);


  return (
    <Segment padded>
      <Header as="h2" dividing color="blue" style={{ marginBottom: '1.5rem' }}>
        <Icon name="clipboard list" />
        Report Generation Status List
      </Header>

      {loading && <Loader active inline="centered" content="Loading..." />}
      {error && <Message negative content={error} />}
      {!loading && !error && data.length === 0 && (
        <Message info content="No Report Generation status found." />
      )}
      <Segment  color="blue" raised>
            <div style={{ overflowX: 'auto' }}>
              <Table celled striped compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Claim Number</Table.HeaderCell>
                    <Table.HeaderCell>Report Status</Table.HeaderCell>
                    <Table.HeaderCell>Report Requested At</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data.map((caseItem: any) => (
                    <Table.Row key={caseItem._id}>
                      <Table.Cell>{caseItem.case_id.claim_number}</Table.Cell>
                      <Table.Cell>
                        {caseItem.status === "processing" && (
                            <span
                            style={{
                                padding: "6px 14px",
                                borderRadius: "20px",
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                            }}
                            >
                            ⏳ Processing
                            </span>
                        )}

                        {caseItem.status === "completed" && (
                            <span
                            style={{
                                padding: "6px 14px",
                                borderRadius: "20px",
                                backgroundColor: "#d4edda",
                                color: "#155724",
                            }}
                            >
                            ✓ Completed
                            </span>
                        )}

                        {caseItem.status === "failed" && (
                            <span
                            style={{
                                padding: "6px 14px",
                                borderRadius: "20px",
                                backgroundColor: "#f8d7da",
                                color: "#721c24",
                            }}
                            >
                            ✕ Failed
                            </span>
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        {moment(caseItem.createdAt).format('DD-MM-YYYY hh:mm A')}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        <div style={{display: "flex", justifyContent: "space-evenly"}}>
                        <Button
                          size="small"
                          icon
                          primary
                          onClick={() => history.push(`/case/view/${caseItem.case_id._id}`)}
                        >
                          Open
                        </Button>
                        <Button
                        negative
                          size="medium"
                          icon
                          onClick={() => handleDelete(caseItem._id)}
                        >
                          Delete
                        </Button>
                        </div>

                      </Table.Cell>

                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          </Segment>
    </Segment>
  );
};

export default ReportStatusList;
